module.exports = __webpack_public_path__ + "img/img-intro2.06c3bc06.jpg";